const state = {
  form: {
    receiveAddrid: '',
    othderAddrid: '',
  },
}

const getters = {
}

const mutations = {
  initForm (state, form, rootState) {
    state.form = {
    }
  },
}

const actions = {
  createPreview ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/trade/order/create-preview', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchCreateOrder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/trade/order/batch-create-order', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchPriceAdjust ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/order/notice/batch-price-adjust', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  priceAdjust ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/order/notice/price-adjust', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  async search ({ state, commit, rootState }, params) {
    // return rootState.axios.get('/magicbuy/v1frontend/dgorder/search', { params })
    const res = await rootState.axios.get('/magicbuy/dgorder/search', {
      params: {
        dgPlatform: 'TAOBAO',
        ...params
      },
      baseURL: 'https://apisp.jyb.com.tw',
    })
    if (Array.isArray(res.data.list)) {
      res.data.list.forEach(order => {
        // 列表和编辑弹窗按对象读取扩展资料，接口可能返回 null 或省略该字段。
        if (order.dgExtras == null) order.dgExtras = {}
      })
    }
    return res
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
